
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen, Tab } from 'devextreme-react/form';

import { FormTextbox, FormDSVUploader, FormDateBox, CardSessions, CardEvents, CardResults, CardEntries, CardEntriesRelay, CardResultsRelay, CompetitionForm } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { COURSES } from '../../../shared/constants';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import ScrollView from 'devextreme-react/scroll-view';

export const CompetitionTabpanel = ({ data, competitionId, onSave }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 840);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


  return (
    <TabPanel
      height={'calc(100vh - 160px)'}
      showNavButtons
      focusStateEnabled={false}
    //deferRendering={false}

    >
      <TabPanelItem title='Details' visible={isSmallScreen}>
        {isSmallScreen && data && (
          <ScrollView height={'100%'} showScrollbar='onScroll'>
            <CompetitionForm
              data={data}
              onSave={onSave}
              isSmallScreen={true}
            />
          </ScrollView>
        )}
      </TabPanelItem>
      <TabPanelItem title='Ergebnisse' visible={data?.competition?.status === 'Ergebnisse vorhanden'}>
        {data?.competition?.status === 'Ergebnisse vorhanden' && (
          <TabPanel
          >
            <TabPanelItem title='Einzel'>
              <CardResults results={data?.results} competitionId={competitionId} traininggroups={data?.traininggroups}></CardResults>
            </TabPanelItem>
            <TabPanelItem title='Staffel'>
              <CardResultsRelay results={data?.resultsRelay} competitionId={competitionId}></CardResultsRelay>
            </TabPanelItem>


          </TabPanel>

        )}
      </TabPanelItem>
      <TabPanelItem title='Meldungen' >
        <TabPanel
        >
          <TabPanelItem title='Einzel'>
            <CardEntries entries={data?.entries} traininggroups={data?.traininggroups} competitionId={competitionId} competition={data?.competition}></CardEntries>
          </TabPanelItem>
          <TabPanelItem title='Staffel'>
            <CardEntriesRelay EntriesRelay={data?.EntriesRelay} competitionId={competitionId} athletes={data?.entries} competition={data?.competition}></CardEntriesRelay>
          </TabPanelItem>


        </TabPanel>

      </TabPanelItem>
      <TabPanelItem title='Abschnitte'>
        <CardSessions sessions={data?.sessions} competitionId={competitionId}></CardSessions>
      </TabPanelItem>
      <TabPanelItem title='Wettkämpfe'>
        <CardEvents events={data?.events} competitionId={competitionId} sessions={data?.sessions} swimstyles={data?.swimstyles}></CardEvents>
      </TabPanelItem>


    </TabPanel>
  );
};
